import React, {FC} from 'react';
import { Link } from 'react-router-dom';
import './BlogCard.scss';
import { IoIosArrowForward } from "react-icons/io";
import {preventOrphans} from '../../helpers';
type BlogProps = {
    title: string;
    img: string;
    description: string;
    url: string
}
const BlogCard:FC<BlogProps> = ({title, img, description,url}) => {
    const processedDescription = description ? preventOrphans(description) : '';

    return (
        <div className='offer-card'>
            <Link to={`/oferta/?${url}`}>
            <div className="blog-card">
                <div className="blog-img">
                    <img src={img} alt="blog"/>
                    <div className="date">
                    <IoIosArrowForward size={32} />
                    </div>
                </div>
                <div className="blog-text">
                    <h3>{title}</h3>
                    <p>{processedDescription}</p>
                </div>
                </div>
                </Link>
        </div>
    );
};

export default BlogCard;